var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureLinesdfc64C854De9Ceb1C09B247F4D52D51B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 93,
    viewBox: "0 0 179 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.99 3C328.99 3 325.99 20 303.99 20C288.96 20 276.99 3 259.99 3C242.99 3 235.19 20.08 214.99 20.08C194.79 20.08 192.72 3 169.99 3C147.26 3 153.74 20.08 125.87 20.08C98 20.08 98.82 3 79.41 3C60 3 56.81 20.08 36.4 20.08C15.99 20.08 3 6 3 6",
    stroke: "#77A042",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.99 26C328.99 26 325.99 43 303.99 43C288.96 43 276.99 26 259.99 26C242.99 26 235.19 43.08 214.99 43.08C194.79 43.08 192.72 26 169.99 26C147.26 26 153.74 43.08 125.87 43.08C98 43.08 98.82 26 79.41 26C60 26 56.81 43.08 36.4 43.08C15.99 43.08 3 29 3 29",
    stroke: "#77A042",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.99 49C328.99 49 325.99 66 303.99 66C288.96 66 276.99 49 259.99 49C242.99 49 235.19 66.08 214.99 66.08C194.79 66.08 192.72 49 169.99 49C147.26 49 153.74 66.08 125.87 66.08C98 66.08 98.82 49 79.41 49C60 49 56.81 66.08 36.4 66.08C15.99 66.08 3 52 3 52",
    stroke: "#77A042",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.99 72C328.99 72 325.99 89 303.99 89C288.96 89 276.99 72 259.99 72C242.99 72 235.19 89.08 214.99 89.08C194.79 89.08 192.72 72 169.99 72C147.26 72 153.74 89.08 125.87 89.08C98 89.08 98.82 72 79.41 72C60 72 56.81 89.08 36.4 89.08C15.99 89.08 3 75 3 75",
    stroke: "#77A042",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureLinesdfc64C854De9Ceb1C09B247F4D52D51B);
export default __webpack_public_path__ + "static/media/figure-lines.dfc64c854de9ceb1c09b247f4d52d51b.dfc64c854de9ceb1c09b247f4d52d51b.svg";
export { ForwardRef as ReactComponent };